<template>
  <create-dialog
    width="80%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div :class="`col-12`">
          <div class="form-group has-label">
            <label>{{ $t('common_words.company') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select mb-3 shadow-sm required-business"
              v-model="model.business_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                class="select-primary"
                v-for="option in businesses"
                :label="option.name"
                :value="option.id"
                :key="option.id + option.name"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <card
        class="custom-shadow-card-header mt-2"
        :title="`${$t('shopping.approval_ranges')} N° ${index}:`"
        v-for="index in model.numberRanges"
        :key="index"
      >
        <div class="row">
          <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
            <div class="form-group has-label">
              <label>{{ $t('shopping.initial_operator') }}: *</label>
              <br />
              <el-select
                @change="inValidOperators(index - 1)"
                :disabled="model.isActivated_details[index - 1] ? true : false"
                clearable
                filterable
                :class="`select-primary custom-width-select mb-3 shadow-sm required-initial_operator${
                  index - 1
                }`"
                v-model="model.min_operator[index - 1]"
                :placeholder="`${$t('common_words.select')}...`"
              >
                <el-option
                  class="select-primary"
                  v-for="option in getOperators"
                  :key="option.id + option.value"
                  :label="option.label"
                  :value="option.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
            <fg-input
              @change="
                inValidValueMinAndMaxOfRange(index - 1),
                  inValidMinValueOfRange(index - 1)
              "
              type="number"
              step="0.01"
              :label="`${$t('shopping.initial_value')}: *`"
              v-model="model.min_value[index - 1]"
              :name="`shopping.initial_value_${index}`"
              :disabled="model.isActivated_details[index - 1] ? true : false"
              v-validate="modelValidations.min_value"
              :error="
                getFieldErrorByIndex('shopping.initial_value', true, index)
              "
              placeholder="..."
            >
            </fg-input>
          </div>
          <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
            <div class="form-group has-label">
              <label>{{ $t('shopping.final_operator') }}:</label>
              <br />
              <el-select
                @change="inValidOperators(index - 1)"
                :disabled="model.isActivated_details[index - 1] ? true : false"
                clearable
                filterable
                :class="`select-primary custom-width-select mb-3 shadow-sm required-final_operator${
                  index - 1
                }`"
                v-model="model.max_operator[index - 1]"
                :placeholder="`${$t('common_words.select')}...`"
              >
                <el-option
                  class="select-primary"
                  v-for="option in getOperators"
                  :key="option.id + option.value"
                  :label="option.label"
                  :value="option.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3">
            <fg-input
              @change="
                inValidValueMinAndMaxOfRange(index - 1),
                  inValidMaxValueOfRange(index - 1)
              "
              :disabled="model.isActivated_details[index - 1] ? true : false"
              type="number"
              step="0.01"
              :class="`required-initial_value${index - 1}`"
              :label="`${$t('shopping.final_value')}:`"
              v-model="model.max_value[index - 1]"
              :name="`shopping.final_value_${index}`"
              v-validate="modelValidations.max_value"
              :error="getFieldErrorByIndex('shopping.final_value', true, index)"
              placeholder="..."
            >
            </fg-input>
          </div>
          <div class="col-12 col-sm-10 col-md-10 col-lg-10 col-xl-10">
            <div class="form-group has-label">
              <label>{{ $t('shopping.approval_responsibles') }}:</label>
              <br />
              <el-select
                :disabled="model.isActivated_details[index - 1] ? true : false"
                @change="selectAllFromSelect('model.user_details_id', users)"
                collapse-tags
                clearable
                filterable
                multiple
                class="select-primary custom-width-select mb-3 shadow-sm"
                v-model="model.user_details_id[index - 1]"
                :placeholder="`${$t('common_words.select')}...`"
              >
                <el-option
                  class="select-primary selected-all"
                  v-for="option in users"
                  :label="option.name"
                  :value="option.id"
                  :key="option.id + option.name"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div
            class="d-flex justify-content-center mt-4 col-12 col-sm-2 col-md-2 col-lg-2 col-xl-2"
          >
            <a
              v-if="isUpdate()"
              v-tooltip.top-center="$t('common_words.add')"
              class="btn plus-button btn-simple btn-link custom-margin-actions"
              @click.prevent="model.numberRanges++"
            >
              <em class="fa fa-plus custom-size-fa-actions"></em>
            </a>
            <div v-if="model.numberRanges > 1 && isDelete()">
              <a
                v-tooltip.top-center="
                  getTextTooltipDelete(model.isActivated_details[index - 1])
                "
                :class="`btn ${
                  model.isActivated_details[index - 1]
                    ? `plus-button`
                    : `danger-button `
                } btn-simple btn-link custom-margin-actions`"
                @click="
                  model.isActivated_details[index - 1]
                    ? handleActivate(index - 1)
                    : handleDelete(index - 1)
                "
              >
                <em
                  :class="`fa ${
                    model.isActivated_details[index - 1]
                      ? `fa-check-circle`
                      : `fa-times`
                  } custom-size-fa-actions`"
                ></em>
              </a>
            </div>
          </div>
        </div>
      </card>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { extendValidators } from 'src/util/vValidateCustom.js';
import { isset } from 'src/util/Util';
import i18n from 'src/i18n';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import SweetAlert from 'src/class/Alerts';

export default {
  name: 'edit-or-create',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [
    MixinAlert,
    MixinDialog,
    MixinForm,
    MixinLoading,
    MixinPermissions,
    MixinValidations,
  ],
  computed: {
    getOperators() {
      return [
        {
          id: '1',
          value: '>',
          label: '>',
        },
        {
          id: '2',
          value: '<',
          label: '<',
        },
        {
          id: '3',
          value: '=',
          label: '=',
        },
        {
          id: '4',
          value: '>=',
          label: '>=',
        },
        {
          id: '5',
          value: '<=',
          label: '<=',
        },
      ];
    },
  },
  data() {
    return {
      disabledField: false,
      businesses: [],
      users: [],
      model: {
        numberRanges: 1,
        business_id: null,
        min_value: [],
        min_operator: [],
        max_value: [],
        max_operator: [],
        user_details_id: [],
        approval_details_id: [],
        isActivated_details: [],
      },
      modelDetail: {
        id: null,
        route: null,
      },
      modelValidations: {
        min_value: { required: true, positive_decimal: true, min: 1 },
        max_value: { positive_decimal: true, min: 1 },
      },
    };
  },
  methods: {
    getSelectAll() {
      this.users = this.concatAll(this.users.splice(1));
    },
    emitDataToRefresh(response) {
      this.$emit('refreshDetail', response);
    },
    getDataRegisterForDeleteOrActivate(index, isForActivate = false) {
      const initial_value = this.model.min_value[index];
      const initial_operator = this.model.min_operator[index];
      const final_value = this.model.max_value[index];
      const final_operator = this.model.max_operator[index];

      return `${
        isForActivate
          ? i18n.t('shopping.activate_range')
          : i18n.t('shopping.deactivate_range')
      } <br /> ${i18n.t('shopping.range')} ${index + 1}:
      ${initial_value} ${initial_operator} ${final_value ? final_value : ''} ${
        final_operator ? final_operator : ''
      }`;
    },
    getTextTooltipDelete(deleted_at) {
      if (deleted_at) return i18n.t('common_words.activate');
      else return i18n.t('common_words.erase');
    },
    handleDelete(index) {
      if (this.model.numberRanges > 1) {
        if (
          isset(this.model.min_value[index]) &&
          isset(this.model.min_operator[index])
        ) {
          SweetAlert.confirm(
            this.getDataRegisterForDeleteOrActivate(index)
          ).then((result) => {
            if (result.value) {
              this.registerSelectDelete(index);
            }
          });
        } else {
          this.registerSelectDelete(index);
        }
      }
    },
    registerSelectDelete(index) {
      if (isset(this.model.approval_details_id[index])) {
        if (this.isUpdate()) {
          this.showHideLoading(true);
          this.modelDetail.route = 'shopping/approvalrangedetail/delete';
          this.modelDetail.id = this.model.approval_details_id[index];
          Axios.destroyMaster(this.modelDetail)
            .then((response) => {
              this.$set(this.model.isActivated_details, index, true);
              this.emitDataToRefresh(response);
              this.showHideLoading();
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
        }
      } else {
        this.model.min_value.splice(index, 1);
        this.model.min_operator.splice(index, 1);
        this.model.max_value.splice(index, 1);
        this.model.max_operator.splice(index, 1);
        this.model.user_details_id.splice(index, 1);
        this.model.numberRanges--;
      }
    },
    handleActivate(index) {
      if (isset(this.model.approval_details_id[index])) {
        SweetAlert.confirm(
          this.getDataRegisterForDeleteOrActivate(index, true)
        ).then((result) => {
          if (result.value) {
            this.registerSelectActivate(index);
          }
        });
      }
    },
    registerSelectActivate(index) {
      if (this.isUpdate()) {
        this.showHideLoading(true);
        this.modelDetail.route = 'shopping/approvalrangedetail/activate';
        this.modelDetail.id = this.model.approval_details_id[index];
        Axios.updateMaster(this.modelDetail)
          .then((response) => {
            this.$set(this.model.isActivated_details, index, false);
            this.emitDataToRefresh(response);
            this.showHideLoading();
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
      }
    },
    setDataModelNullForCreation() {
      for (let index = 0; index < this.model.numberRanges; index++) {
        if (
          !isset(this.model.max_value[index]) &&
          !isset(this.model.max_operator[index])
        ) {
          this.$set(this.model.max_value, index, null);
          this.$set(this.model.max_operator, index, null);
        }
        if (
          isset(this.model.min_value[index]) &&
          isset(this.model.min_operator[index])
        ) {
          if (!isset(this.model.approval_details_id[index])) {
            this.$set(this.model.approval_details_id, index, -1);
          }
        }
      }
    },
    messageOfInvalidRange(index) {
      const initial_value = this.model.min_value[index];
      const final_value = this.model.max_value[index];

      return `${i18n.t('shopping.range_initial_value_error')} <br /> 
      <strong> ${i18n.t('shopping.range')} ${index + 1}: ${i18n.t(
        'shopping.initial_value'
      )} :
      ${initial_value} - ${i18n.t(
        'shopping.final_value'
      )} : ${final_value} </strong>`;
    },
    inValidValueMinAndMaxOfRange(index) {
      if (
        isset(this.model.min_value[index]) &&
        isset(this.model.max_value[index])
      ) {
        let min_value = parseFloat(this.model.min_value[index]);
        let max_value = parseFloat(this.model.max_value[index]);
        if (min_value >= max_value) {
          SweetAlert.warning(this.messageOfInvalidRange(index));
          this.$set(this.model.max_value, index, null);
        }
      }
    },
    messageOfInValidMinValue(index, min_value_current, max_value_before) {
      return `${i18n.t('shopping.range_initial_previous_error')} <br /> 
      <strong> ${i18n.t('shopping.range')} ${index + 1}: <br /> ${i18n.t(
        'shopping.current_range_initial_value'
      )} :
      ${min_value_current} <br /> ${i18n.t(
        'shopping.previous_range_final_value'
      )} : ${max_value_before} </strong>`;
    },
    messageOfInValidMaxValue(index, min_value_after, max_value_current) {
      return `${i18n.t('shopping.range_final_next_error')} <br /> 
      <strong> ${i18n.t('shopping.range')} ${index + 1}: <br /> ${i18n.t(
        'shopping.current_range_final_value'
      )} :
      ${max_value_current} <br /> ${i18n.t(
        'shopping.next_range_initial_value'
      )} : ${min_value_after} </strong>`;
    },
    inValidMinValueOfRange(index) {
      const min_value_current = parseFloat(this.model.min_value[index]);
      const max_value_before = parseFloat(this.model.max_value[index - 1]);
      if (index > 0 && isset(max_value_before)) {
        if (min_value_current <= max_value_before) {
          SweetAlert.warning(
            this.messageOfInValidMinValue(
              index,
              min_value_current,
              max_value_before
            )
          );
          this.$set(this.model.min_value, index, null);
        }
      }
    },
    inValidMaxValueOfRange(index) {
      if (index + 1 <= this.model.numberRanges) {
        const min_value_after = parseFloat(this.model.min_value[index + 1]);
        const max_value_current = parseFloat(this.model.max_value[index]);
        if (isset(min_value_after) && max_value_current >= min_value_after) {
          SweetAlert.warning(
            this.messageOfInValidMaxValue(
              index,
              min_value_after,
              max_value_current
            )
          );
          this.$set(this.model.max_value, index, null);
        }
      }
    },
    inValidOperators(index) {
      if (
        isset(this.model.min_operator[index]) &&
        isset(this.model.max_operator[index]) &&
        this.model.min_operator[index] === this.model.max_operator[index]
      ) {
        SweetAlert.warning(i18n.t('shopping.operators_must_not_be_equal'));
        this.$set(this.model.max_operator, index, null);
      }
    },
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.business_id)) {
            return this.validationInputsRequired('business');
          }
          for (let i = 0; i < this.model.numberRanges; i++) {
            if (!isset(this.model.min_operator[i])) {
              return this.validationInputsRequired(`initial_operator${i}`);
            } else if (
              isset(this.model.max_value[i]) &&
              !isset(this.model.max_operator[i])
            ) {
              return this.validationInputsRequired(`final_operator${i}`);
            } else if (
              !isset(this.model.max_value[i]) &&
              isset(this.model.max_operator[i])
            ) {
              return this.validationInputsRequired(`initial_value${i}`);
            }
          }
          this.setDataModelNullForCreation();
          this.$emit('addEdit', this.model);
        }
      });
    },
  },
  created() {
    extendValidators();
  },
  mounted() {
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('businesses/only'),
        Axios.getMasters('users/indexfield'),
      ])
        .then(([responseBusinesses, responseUsers]) => {
          this.users = this.concatAll(responseUsers.data.data);
          this.businesses = responseBusinesses.data.data;
        })
        .catch((error) => this.showMessageErrors(error));
    }
  },
  updated() {
    if (sessionStorage.getItem('editForm') && this.isUpdate()) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const { id, business_id, approval_range_details } = editForm;
      this.model.numberRanges = approval_range_details.length;
      let users = approval_range_details.map((detail) => detail.users);
      for (let index = 0; index < users.length; index++) {
        if (!Array.isArray(this.model.user_details_id[index])) {
          this.$set(this.model.user_details_id, index, []);
        }

        if (users[index] && users[index].length > 0) {
          this.model.user_details_id[index] = users[index].map(
            (user) => user.id
          );
        }
      }
      this.model = {
        ...this.model,
        id,
        business_id,
        min_value: approval_range_details.map((detail) => detail.min_value),
        min_operator: approval_range_details.map(
          (detail) => detail.min_operator
        ),
        max_value: approval_range_details.map((detail) => detail.max_value),
        max_operator: approval_range_details.map(
          (detail) => detail.max_operator
        ),
        approval_details_id: approval_range_details.map((detail) => detail.id),
        isEdit: true,
        isActivated_details: approval_range_details.map(
          (detail) => detail.deleted_at
        ),
      };
      sessionStorage.removeItem('editForm');
    }
  },
};
</script>

<style scoped>
.plus-button {
  color: green;
}
.danger-button {
  color: red;
}
</style>
